import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import userPool from "./cognito";
import { jwtDecode } from "jwt-decode";

const AuthService = {
  login: (username, password) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: username,
        Pool: userPool,
      });

      const authDetails = new AuthenticationDetails({
        Username: username,
        Password: password,
      });

      user.authenticateUser(authDetails, {
        onSuccess: (session) => {
          localStorage.setItem("token", session.getIdToken().getJwtToken());
          resolve(session);
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  },

  logout: () => {
    localStorage.removeItem("token");
    window.location.reload();
  },

  getToken: () => localStorage.getItem("token"),

  isAuthenticated: () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now();
  },

  forgotPassword: (username) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: username,
        Pool: userPool,
      });

      user.forgotPassword({
        onSuccess: (data) => {
          resolve(data);
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });
  },

  confirmForgotPassword: (username, verificationCode, newPassword) => {
    return new Promise((resolve, reject) => {
      try {
        const user = new CognitoUser({
          Username: username,
          Pool: userPool,
        });

        if (!user) {
          console.error('Failed to create Cognito user');
          reject(new Error('Failed to initialize Cognito user'));
          return;
        }

        user.confirmPassword(verificationCode, newPassword, {
          onSuccess: (data) => {
            console.log('Password reset successful:', data);
            resolve(data);
          },
          onFailure: (err) => {
            console.error('Password reset failed:', err);
            reject(err);
          },
        });
      } catch (error) {
        console.error('Error in confirmPassword:', error);
        reject(error);
      }
    });
  },

  changePassword: (oldPassword, newPassword) => {
    return new Promise((resolve, reject) => {
      const user = userPool.getCurrentUser();
      
      if (!user) {
        reject(new Error("No user is currently logged in"));
        return;
      }

      user.getSession((err, session) => {
        if (err) {
          reject(err);
          return;
        }

        user.changePassword(oldPassword, newPassword, (err, result) => {
          if (err) {
            reject(err);
            return;
          }
          resolve(result);
        });
      });
    });
  },
};

export default AuthService;
